import React from "react";

interface TableCellValueProps {
  value: React.ReactNode;
  hasTooltip?: boolean;
  tooltipDirection?: string;
}

export const TableCellValue: React.FC<TableCellValueProps> = ({ value }) => {
  return (
      <p className="table-inner-text">{value}</p>
  );
};
